import { useEffect, useState } from "react";
import {
  InitiateAuthCommand,
  CognitoIdentityProviderClient,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDispatch } from "react-redux";
import { updateTokenExpiryStatus } from "../redux/tokenSlice";

const TokenRefresh = () => {
  const dispatch = useDispatch()
  const poolData = {
    ClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    UserPoolId: process.env.REACT_APP_USER_POOL_ID,
  };

  const cognitoClient = new CognitoIdentityProviderClient({
    region: process.env.REACT_APP_AWS_REGION,
  });

  const [refreshTimer, setRefreshTimer] = useState(null);

  const refreshToken = async () => {
    console.log("Refreshing token...");
    try {
      const storedRefreshToken = sessionStorage.getItem("refreshToken");
      if (!storedRefreshToken) return;

      const refreshAuthParams = {
        AuthFlow: "REFRESH_TOKEN_AUTH",
        ClientId: poolData.ClientId,
        AuthParameters: {
          REFRESH_TOKEN: storedRefreshToken,
        },
      };

      const refreshCommand = new InitiateAuthCommand(refreshAuthParams);
      const refreshResult = await cognitoClient.send(refreshCommand);

      const newIdToken = refreshResult.AuthenticationResult.IdToken;
      const newExpiryTime = refreshResult.AuthenticationResult.ExpiresIn;

      sessionStorage.setItem("idToken", newIdToken);
      sessionStorage.setItem("expiryTime", newExpiryTime);

      console.log("Token refreshed successfully");

      const nextRefreshTime = (newExpiryTime - 300) * 1000;
      setRefreshTimer(setTimeout(refreshToken, nextRefreshTime));
    } catch (error) {
      dispatch(updateTokenExpiryStatus(true))
      console.error("Error refreshing token:", error);
    }
  };

  useEffect(() => {
    const expiryTime = sessionStorage.getItem("expiryTime");
    if (expiryTime) {
      const refreshTime = (Number(expiryTime) - 300) * 1000;
      const timer = setTimeout(refreshToken, refreshTime);
      setRefreshTimer(timer);
    }

    return () => clearTimeout(refreshTimer);
  }, []);

  return null;
};

export default TokenRefresh;